import _ from 'lodash'
export default class ValidatorHelper {
    constructor() {
        this.errors = null;
        this.verify = []
        this.typeToString = {
            required: (label) => `Informe o  campo: ${label}`,
            validCNPJ: (label) => `${label} invalido`,
            validCPF: (label) => `${label} invalido`,
        }
        this.typeValidValue = {
            required: (values, param) => _.get(values, param) ? true : false,
            validCNPJ: (values, param) => validarCNPJ(_.get(values, param)),
            validCPF: (values, param) => validarCPF(_.get(values, param)),
        }
    }
    addRequired(param, label) {
        this.verify.push({ type: "required", label, param })
    }

    addRequiredFieldConfig(fieldConfig) {
        for (const field in fieldConfig) {
            let conf = fieldConfig[field]
            if (conf.required) {
                this.addRequired(field, conf.label)
            }
        }
    }
    addValidCNPJ(param, label) {
        this.verify.push({ type: "validCNPJ", label, param })
    }
    addValidCPF(param, label) {
        this.verify.push({ type: "validCPF", label, param })
    }


    valid(values) {
        let erros = []
        this.verify.forEach(v => {
            if (!this.typeValidValue[v.type](values, v.param)) {
                erros.push(this.typeToString[v.type](v.label))
            }
        });
        return erros

    }
}

export function validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj === '') return false;

    if (cnpj.length !== 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado.toString() !== digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado.toString() !== digitos.charAt(1))
        return false;

    return true;
}

export function validarCPF(strCPF) {
    var resto, soma = 0;

    // Usuário não digitou CPF, mas CPF não é campo obrigatório
    if (strCPF.length === 0) return true

    // Usuário digitou CPF, mas faltou dígito
    if (strCPF.length > 0 && strCPF.length < 11) return false

    if (strCPF === '00000000000') return false;
    if (strCPF === '11111111111') return false;
    if (strCPF === '22222222222') return false;
    if (strCPF === '33333333333') return false;
    if (strCPF === '44444444444') return false;
    if (strCPF === '55555555555') return false;
    if (strCPF === '66666666666') return false;
    if (strCPF === '77777777777') return false;
    if (strCPF === '88888888888') return false;
    if (strCPF === '99999999999') return false;

    for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) {
        resto = 0;
    }
    if (resto !== parseInt(strCPF.substring(9, 10))) {
        return false;
    }

    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
}